import $ from 'domtastic'




/* POLYFILL IE
----------------------------------------------------------------------------------------------------*/

export default class PolyfillIE {

    constructor() {
        this.bindElems()
        this.checkIE()
    }


    bindElems() {
        this.$els = {
            imgs: $(''), // Define elements here
        }
    }


    checkIE() {
        if (!APP.Browser.isExplorer) return

        this.$els.imgs.forEach((el) => {
            const $placeholdiv = $('<div>')

            const classes = el.getAttribute('class')

            if (el.nodeName === 'IMG') {
                $placeholdiv.attr({
                    class     : classes,
                    style     : el.className.includes('lazy') ? '' : `background-image: url("${el.getAttribute('src')}");`,
                    'data-background-image' : `${el.getAttribute('data-src')}`,
                })

                $placeholdiv.addClass('objectfitcover-polyfill')
                el.replaceWith($placeholdiv[0])
            }
        })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



